module.exports = "https://store.zigzag.kr/resources/arm64/20260309-1822-ba8f7d95c5_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";